import {Skeleton, type SkeletonProps} from "@mui/material";

export function CustomSkeleton({sx, ...props}: SkeletonProps) {
    return (
        <Skeleton {...props} sx={{'&.MuiSkeleton-text': {transform: 'scale(1)'}, ...sx}}/>
    )
}
